import { Visualize3dObject, getComponent } from '../../models/visualize3d-object';
import { OnObject3dInit } from '../../view-interactions/object-3d-events';
import { Injectable } from '@angular/core';
import { ThreeJsMaterialModifierComponent } from '../three-js-material-modifier-component';
import { setMaterialRecursively } from '../../utility/viewer/material-utility';
import { createThreeJsMaterial } from '../../models/three-js-material';
import { Object3D } from 'three';

@Injectable({
  providedIn: 'root',
})
export class ThreeJSMaterialComponentHandler implements OnObject3dInit {
  initialize(object3d: Object3D, v3dObject: Visualize3dObject): void {
    const component = getComponent<ThreeJsMaterialModifierComponent>(v3dObject, 'ThreeJsMaterialModifier');
    if (!component) {
      throw new Error('No ThreeJsMaterialModifier component present in Object3d');
    }
    const material = createThreeJsMaterial(component.material);
    setMaterialRecursively(object3d, material, component.material.preserveColor);
  }
}
